import React, { Component, useEffect, useState } from "react";
import {
  API_TOKEN_NAME,
  IMAGE_URL,
  SITE_URL,
  WEBSITEPAGE_URL,
  USER_ID,
  USER_LOCAL_ID,
} from "../../../constants";
import { scAxiosAdmin } from "../../..";
import { FiSearch } from "react-icons/fa";
import icons_rotate from "../../../images/icons-rotate.png";
import $ from "jquery";
import HomeSlider from "./HomeSlider";
import { Link } from "react-router-dom";
import FindDoctorAndDepartmentPopup from "../FindDoctorAndDepartmentPopup";
import SendUsInquiry from "../SendUsInquiry";
import BookAppointmentPopup from "../BookAppointmentPopup";
import PopupIndex4 from "../PopupIndex4";
const HomeSearchUp = ({
  departments,
  banners,
  findADoctorPopupClicked,
  bookAppointmentPopupClicked,
  setDepartments,
  setBanners,
  setFindADoctorPopupClicked,
  setBookAppointmentPopupClicked,
  hoverId,
  setHoverId,
}) => {
  // const [departments, setDepartments] = useState([]);
  // const [banners, setBanners] = useState([]);
  // const [findADoctorPopupClicked, setFindADoctorPopupClicked] = useState(false);
  // const [bookAppointmentPopupClicked, setBookAppointmentPopupClicked] =
  //   useState(false);
  // useEffect(() => {
  //   const getAllBannerButtonData = (data) => {
  //     try {
  //       const req = scAxiosAdmin
  //         .request("/bannerbutton/getallbannerbtndata", {
  //           method: "get",
  //           headers: {
  //             Accept: "application/json",
  //             Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
  //           },
  //           params: {
  //             ...data,
  //           },
  //         })
  //         .then((data) => {
  //           if (data.status === 200) {
  //             setDepartments(data.data.data);
  //           }
  //         })
  //         .catch((e) => {
  //           console.log("your log output", e);
  //         });
  //     } catch (error) {}
  //   };
  //   getAllBannerButtonData();
  // }, []);
  // useEffect(() => {
  //   const getAllBanner = (data) => {
  //     try {
  //       const req = scAxiosAdmin
  //         .request("/banner", {
  //           method: "get",
  //         })
  //         .then((data) => {
  //           if (data.status === 200) {
  //             setBanners(data.data);
  //           }
  //         })
  //         .catch((e) => {
  //           console.log("your log output", e);
  //         });
  //     } catch (error) {}
  //   };
  //   getAllBanner();
  // }, []);
  // console.log("dafdsf", banners);
  return (
    <div className="pt-0 pt-lg-4">
      {/* <h1
        data-aos="fade-up"
        data-aos-duration="1000"
        style={{ color: "black", textAlign: "center" }}
      ></h1> */}
      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-column-reverse flex-lg-row gap-3 gap-lg-1">
            <div
              style={{ backgroundColor: "#F7F5EF" }}
              className="card h-100 d-flex flex-lg-column flex-row homeBannerTabs justify-content-between gap-2 border-0 shadow-none"
            >
              <div
                className="h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5"
                style={{
                  backgroundColor: "#AF9763",

                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                data-bs-toggle="offcanvas"
                data-bs-target="#FindADoctorCanvas"
                aria-controls="FindADoctorCanvas"
                onClick={() => setFindADoctorPopupClicked(true)}
              >
                <img src="/assets/images/profile.png" alt="" className="pb-2" />
                <h5
                  className="pb-0 mb-0"
                  style={{
                    width: "fit-content",
                    color: "#fff",
                  }}
                >
                  Find a Doctor
                </h5>
              </div>
              {localStorage.getItem(USER_LOCAL_ID) ? (
                <div
                  className="h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5"
                  style={{
                    backgroundColor: "#AF9763",

                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  role="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#BookAppointMent"
                  aria-controls="BookAppointMent"
                  onClick={() => setBookAppointmentPopupClicked(true)}
                >
                  {/* if modal backdrop need to be visible on after nav just uncomment the css in style.css .modal-backdrop.show in line around 3638 */}
                  <img
                    src="/assets/images/calender.png"
                    alt=""
                    className="pb-2"
                  />
                  <h5
                    className="pb-0 mb-0"
                    style={{
                      width: "fit-content",
                      color: "#fff",
                    }}
                  >
                    Book Appointment
                  </h5>
                </div>
              ) : (
                <div
                  className="h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5"
                  style={{
                    backgroundColor: "#AF9763",

                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  // data-bs-toggle="offcanvas"
                  // data-bs-target="#BookAppointMent"
                  // aria-controls="BookAppointMent"
                  // className="dropdown-item"
                  href="#offcanvasExample"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="offcanvasExample"
                >
                  <img
                    src="/assets/images/calender.png"
                    alt=""
                    className="pb-2"
                  />
                  <h5
                    className="pb-0 mb-0"
                    style={{
                      width: "fit-content",
                      color: "#fff",
                    }}
                  >
                    Book Appointment
                  </h5>
                </div>
              )}
              <div
                className="h-100 d-flex justify-content-center flex-column align-items-center sideButtonMenu make-orange py-5"
                style={{
                  backgroundColor: "#AF9763",

                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                data-bs-toggle="offcanvas"
                data-bs-target="#SendUsInquiry"
                aria-controls="SendUsInquiry"
              >
                <img src="/assets/images/plus.png" alt="" className="pb-2" />
                <h5
                  className="pb-0 mb-0"
                  style={{
                    width: "fit-content",
                    color: "#fff",
                  }}
                >
                  Send us an Inquiry
                </h5>
              </div>
            </div>
            <div className="homeBanner">
              <HomeSlider banners={banners}></HomeSlider>
            </div>
          </div>
        </div>
        <div
          className="col-12 d-flex flex-column justify-content-center align-items-center mt-4 d-none d-md-block"
          style={{ maxWidth: "100%" }}
        >
          <div
            className="d-flex flex-row justify-content-between align-items-center mt-3 p-2 w-100 gap-3 overflow-auto"
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "5px",
            }}
          >
            {departments.length > 0
              ? departments.slice(0, 6).map((banner_button) => {
                  let buttonSlug = banner_button.department_name
                    .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\\/]/gi, "")
                    .replace(/\s+/g, "-")
                    .replace(/-$/, "")
                    .toLowerCase();

                  return (
                    <div className="p-0 department-menu">
                      <a
                        href={SITE_URL + "/departments/" + buttonSlug}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className="card cardHover"
                          style={{
                            width: "100%",
                            margin: "0 auto",
                            height: "45px",
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: "5px",
                            backgroundColor: "#F7F5EF",
                            // color: "#AF9763",
                            fontWeight: "500",
                          }}
                          onMouseEnter={() => setHoverId(banner_button.id)}
                          onMouseLeave={() => setHoverId(null)}
                          onTouchStart={() => setHoverId(banner_button.id)} // Works on mobile
                          onTouchCancel={() => setHoverId(null)} // Optional: Hide on touch end
                        >
                          <div
                            className="p-2 d-flex justify-content-center align-items-center w-100"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div className="">
                              {banner_button.banner_btn_icon ? (
                                <img
                                  // className="ql-background"
                                  src={`${IMAGE_URL}BannerButtonImg/${
                                    hoverId === banner_button.id &&
                                    banner_button.banner_btn_hover_icon
                                      ? banner_button.banner_btn_hover_icon
                                      : banner_button.banner_btn_icon
                                  }`}
                                  alt="avtars"
                                  style={{
                                    borderRadius: "50%",
                                    width: "100%",
                                    maxWidth: "27px",
                                  }}
                                />
                              ) : (
                                <i className="fa-solid fa-circle-right"></i>
                              )}
                            </div>

                            <p className="px-2">
                              {banner_button.banner_btn_text}
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })
              : ""}
            <div className="p-0 department-menu d-none d-lg-block">
              <Link
                className="d-inline-block w-100"
                style={{ textDecoration: "none" }}
                to={"/pages/departments"}
              >
                <div
                  className="card "
                  style={{
                    width: "100%",
                    margin: "0 auto",
                    height: "45px",
                    display: "flex",
                    justifyContent: "center",
                    borderRadius: "5px",
                    backgroundColor: "#AF9763",
                    color: "#ffffff",
                    fontWeight: "500",
                  }}
                >
                  <button
                    style={{
                      padding: "11px",
                      color: "#fff",
                      textTransform: "capitalize",
                      border: "none",
                      backgroundColor: "transparent",
                      borderRadius: "6px",
                      fontWeight: "500",
                      width: "100%",
                    }}
                    className="deptBtnFont"
                  >
                    View All Departments
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center mb-2 w-100  d-none d-md-block">
          <div
            className="py-3 department-menu d-block d-lg-none w-100 text-center"
            style={{
              backgroundColor: "#ffffff",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
          >
            <Link
              className="d-inline-block w-50"
              style={{ textDecoration: "none" }}
              to={"/pages/departments"}
            >
              <div
                className="card "
                style={{
                  width: "100%",
                  margin: "0 auto",
                  height: "45px",
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "5px",
                  backgroundColor: "#AF9763",
                  color: "#ffffff",
                  fontWeight: "500",
                }}
              >
                <button
                  style={{
                    padding: "11px",
                    color: "#fff",
                    textTransform: "capitalize",
                    border: "none",
                    backgroundColor: "transparent",
                    borderRadius: "6px",
                    fontWeight: "500",
                    width: "100%",
                  }}
                  className="deptBtnFont"
                >
                  View All Departments
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <FindDoctorAndDepartmentPopup
        findADoctorPopupClicked={findADoctorPopupClicked}
        setFindADoctorPopupClicked={setFindADoctorPopupClicked}
      ></FindDoctorAndDepartmentPopup>
      <SendUsInquiry></SendUsInquiry>
      {/* if modal backdrop need to be visible on after nav just uncomment the css in style.css .modal-backdrop.show in line around 3638 */}
      <BookAppointmentPopup
        bookAppointmentPopupClicked={bookAppointmentPopupClicked}
        setBookAppointmentPopupClicked={setBookAppointmentPopupClicked}
      ></BookAppointmentPopup>
      <PopupIndex4></PopupIndex4>
    </div>
  );
};

export default HomeSearchUp;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/HomeSearchUp.js